<template>
    <div>
        <section class="hero">
            <div class="hero-body">
                <div class="container">
                    <h1 class="title has-text-centered">
                        チラシデータ確認
                    </h1>
                </div>
            </div>
        </section>
        <section>
            <div class="columns">
                <section class="column is-half is-offset-one-quarter">
                    <b-field
                        label="スポンサー"
                        :type="errors.sponsor ? 'is-danger' : ''"
                        :message="errors.sponsor ? errors.sponsor : ''"
                    >
                        <b-input
                            v-model="form.sponsor"
                            readonly="true"
                        ></b-input>
                    </b-field>

                    <b-field label="タイトル">
                        <b-input v-model="form.title" readonly="true"></b-input>
                    </b-field>

                    <b-field label="お問い合わせ先">
                        <b-input
                            v-model="form.contact"
                            type="textarea"
                            readonly="true"
                        ></b-input>
                    </b-field>

                    <b-field label="掲載期間">
                        <b-input
                            v-model="form.publicationPeriod"
                            readonly="true"
                        >
                        </b-input>
                    </b-field>

                    <b-field label="住所">
                        <b-input
                            v-model="form.address"
                            type="textarea"
                            readonly="true"
                        ></b-input>
                    </b-field>

                    <b-field label="電話番号">
                        <b-input
                            v-model="form.tel"
                            type="textarea"
                            readonly="true"
                        ></b-input>
                    </b-field>

                    <b-field label="ホームページ">
                        <b-input
                            v-model="form.website"
                            type="textarea"
                            readonly="true"
                        ></b-input>
                    </b-field>

                    <b-field
                        label="チラシ画像"
                        :type="errors.images ? 'is-danger' : ''"
                        :message="errors.images ? errors.images : ''"
                    />
                    <div v-for="i in [0, 1, 2, 3, 4, 5, 6]" :key="i">
                        <b-field grouped class="m-b-10">
                            <div class="p-t-5 p-b-5 m-r-20 area-block">
                                <p>チラシ画像 {{ i + 1 }}</p>
                            </div>
                            <b-button
                                class="button m-r-10"
                                @click="imageModal(form.images[i])"
                                v-if="form.images[i]"
                            >
                                確認
                            </b-button>
                        </b-field>
                    </div>
                    <b-field grouped class="m-b-10">
                        <div class="p-t-5 m-r-50 area-block">
                            <p>ロゴ画像</p>
                        </div>
                        <b-button
                            class="button m-r-10"
                            @click="imageModal(form.logoImage)"
                            v-if="form.logoImage"
                        >
                            確認
                        </b-button>
                    </b-field>

                    <b-field label="" class="m-t-20 is-pulled-right">
                        <router-link to="/flyers">
                            <b-button class="is-medium">戻る</b-button>
                        </router-link>
                    </b-field>
                </section>
            </div>
        </section>
    </div>
</template>

<script>
import { API, graphqlOperation, Storage } from 'aws-amplify'
import { getFlyer as getFlyerQuery } from '@/graphql/queries'
import moment from 'moment'

export default {
    name: 'ViewFlyer',
    props: ['id'],
    data: function() {
        return {
            form: {
                title: '',
                contact: '',
                address: '',
                tel: '',
                website: '',
                permalink: '',
                images: [],
                logoImage: '',
                sponsor: '',
                publicationPeriod: [],
                status: null
            },
            errors: {}
        }
    },
    created: async function() {
        await API.graphql(
            graphqlOperation(getFlyerQuery, {
                id: this.id
            })
        )
            .then(response => {
                this.form.title = response.data.getFlyer.title
                this.form.contact = response.data.getFlyer.contact
                this.form.address = response.data.getFlyer.address
                this.form.tel = response.data.getFlyer.tel
                this.form.website = response.data.getFlyer.website
                this.form.permalink = response.data.getFlyer.permalink
                this.form.logoImage = response.data.getFlyer.logoImage
                this.form.images = response.data.getFlyer.images
                this.form.sponsor = response.data.getFlyer.sponsor
                this.form.publicationPeriod =
                    moment(response.data.getFlyer.startDate).format(
                        'YYYY/MM/DD'
                    ) +
                    ' - ' +
                    moment(response.data.getFlyer.endDate).format('YYYY/MM/DD')
            })
            .catch(err => {
                console.log(err)
                this.$buefy.toast.open({
                    message: 'チラシデータの取得に失敗しました',
                    type: 'is-danger'
                })
            })
    },
    methods: {
        imageModal(key) {
            Storage.get(key)
                .then(result => {
                    this.$buefy.modal.open(
                        '<div class="has-text-centered"><img src="' +
                            result +
                            '"></div>'
                    )
                })
                .catch(err => {
                    console.log(err)
                    this.$buefy.toast.open({
                        message: '画像の取得に失敗しました',
                        type: 'is-danger'
                    })
                })
        }
    }
}
</script>

<style scoped>
.area-block {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    justify-items: center;
}
</style>
